import { render, staticRenderFns } from "./CommunityQnaDetail.vue?vue&type=template&id=0b5c7471&scoped=true&"
import script from "./CommunityQnaDetail.vue?vue&type=script&lang=js&"
export * from "./CommunityQnaDetail.vue?vue&type=script&lang=js&"
import style0 from "./CommunityQnaDetail.vue?vue&type=style&index=0&id=0b5c7471&prod&scoped=true&lang=css&"
import style1 from "./CommunityQnaDetail.vue?vue&type=style&index=1&id=0b5c7471&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5c7471",
  null
  
)

export default component.exports